module.exports = __webpack_public_path__ + "258e0ebaffe64fd48eaf6f119b57956d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/skateboard-green-s.png
// module id = 2555
// module chunks = 0